import React, { useState } from "react";
import Button from "../Button";
import { useNavigate } from "react-router-dom";
import NoDataFound from "../NoDataFound";
import useNetworkServices from "../../../Networking/baseAPIManager";
import { Toastify } from "../Toastify";

const MerchantCard = ({ data, setRefresh }) => {
  const { merchantStatus } = useNetworkServices();
  const [type, setType] = useState("info");
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const BASE_URL_IMG = process.env.REACT_APP_BASE_URL_IMG || "";

  const navigate = useNavigate();

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <p className="col-span-full text-center text-gray-500">
        <NoDataFound />
      </p>
    );
  }
  const merchantStatusUpdate = (currentstatus) => {
    const QueryParams = {
      id: currentstatus?._id,
      is_active: currentstatus?.is_active === true ? false : true,
    };

    const queryString = new URLSearchParams(QueryParams).toString();

    merchantStatus(queryString)
      .then((response) => {
        console.log(response.data.message, "response====>");
        setType("success");
        setMessage(
          response?.data?.message || "Merchant status update successfully"
        );
        setShow(true);
        setRefresh(true);
      })
      .catch((error) => {
        setType("error");
        setMessage(
          error?.response?.data?.message || "Merchant status update failed"
        );
        setShow(true);
        console.log(error.response.data.message, "errorr");
      });
  };

  return (
    <>
      {data.map((items, index) => {
        const isActive = items?.is_active || false;
        const fullAddress = `${
          items?.businessDetils?.businessCity || "N/A"
        } , ${items?.businessDetils?.businessState || " "}`;
        const brandImage = items?.businessDetils?.brandImage
          ? `${BASE_URL_IMG}/${items?.businessDetils?.brandImage}`
          : "https://via.placeholder.com/100";

        return (
          <div key={index} className="border rounded-lg shadow-md max-w-sm">
            <div className="p-4 bg-gradient-to-r from-customYellow1 to-customYellow2">
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="text-xl md:text-lg font-semibold text-gray-800 break-words">
                    {items?.businessDetils?.shopName || "Shop Name"} 
                  </h3>
                  <button
                    onClick={() => merchantStatusUpdate(items)}
                    className={`mt-2 pe-3 rounded-lg ${
                      isActive ? "bg-green-100" : "bg-red-100"
                    }`}
                  >
                    <div
                      className={`w-4 h-4 rounded-full transition-transform ${
                        isActive ? "translate-x-4 bg-green-500" : "bg-red-500"
                      }`}
                    ></div>
                  </button>
                </div>
                <div className="w-24 h-24">
                  <img
                    src={brandImage}
                    alt="Stationery"
                    className="h-full w-full object-contain rounded-xl bg-yellow-50"
                  />
                </div>
              </div>
              <Button
                className="mt-4 px-4 py-1 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600"
                label="More Details"
                onClick={() =>
                  navigate("/marchant_overview/detail", { state: items })
                }
              />
            </div>
            <div className=" p-4 space-y-2 text-gray-700 flex-wrap break-words">
              <p className="flex justify-between">
                <span className="font-bold">Location:</span>
                <span className="text-blue-500">{fullAddress}</span>
              </p>
              <p className="flex justify-between">
                <span className="font-bold">Pin code:</span>
                <span className="text-blue-500">
                  {items?.businessDetils?.businessPinCode || "N/A"}
                </span>
              </p>
            </div>
          </div>
        );
      })}

      <Toastify type={type} message={message} show={show} setShow={setShow} />
    </>
  );
};

export default MerchantCard;
